import React from "react";
import { ReactTyped } from "react-typed";
import c1 from "./../../public/image/c1.png";
import c2 from "./../../public/image/c2.png";
import { Carousel } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Helmet } from "react-helmet";

const AboutUs = () => {
    return (
        <div className="px-sm-2">
            <header>
                <Helmet>
                    <title>
                        {" "}
                        تماس با ما | آلماتک | روستابازار زنجان | مواد غذایی | میوه و
                        سبزیجات | آجیل و خشکبار | ادویه جات | شوینده و لوازم
                        بهداشتی | تره بار | کالاهای اساسی | محصولات ویژه | برنج
                        روغن | حبوبات | لبنیات
                    </title>
                    <meta
                        name="description"
                        content={`${"فروش انواع کالاهای اساسی | برنج | حبوبات | مواد غذایی | میوه و سبزیجات | تره بار | آجیل و خشکبار | شوینده و لوازم بهداشتی | لبنیات و ..."}`}
                    />
                </Helmet>
                <h5 className="fw-bold text-dark text-center mb-3 rtl">
                    <ReactTyped
                        strings={[
                            "آلماتک « بازارچه عرضه میوه ، تره بار و کالاهای اساسی روستابازار زنجان »",
                        ]}
                        typeSpeed={80}
                        backSpeed={100}
                        backDelay={2000}
                        // loop
                        smartBackspace
                    />
                </h5>
            </header>
            <p style={{ textAlign: "justify" }} className="alert alert-light">
                « آلماتک بزرگ‌ترین فروشگاه خواربار و میوه در استان است؛ جایی که
                خرید تنها یک کار روزمره نیست، بلکه تجربه‌ای تازه و متفاوت محسوب
                می‌شود. در آلماتک شما با محیطی مدرن، صندوق‌های متعدد و خدمات
                سریع روبه‌رو می‌شوید تا خریدتان ساده‌تر و لذت‌بخش‌تر باشد. »
            </p>
            <div
                style={{
                    width: "400px",
                    // height: "375px",
                    maxWidth: "100%",
                    borderRadius: "10px",
                    overflow: "hidden",
                }}
                className="mx-auto my-3"
            >
                <Carousel controls={false}>
                    <Carousel.Item>
                        <LazyLoadImage
                            width={"100%"}
                            // height={375}
                            src={c1}
                            effect="blur"
                            style={{
                                objectFit: "cover",
                                borderRadius: "10px",
                                maxWidth: "100%",
                            }}
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <LazyLoadImage
                            width={"100%"}
                            // height={375}
                            src={c2}
                            style={{
                                objectFit: "cover",
                                borderRadius: "10px",
                                maxWidth: "100%",
                            }}
                            effect="blur"
                        />
                    </Carousel.Item>
                </Carousel>
            </div>
            <p style={{ textAlign: "justify" }} className="alert alert-light">
                « نام آلماتک از ترکیب «آلما» به معنای سیب و خرید، و «تک» به
                معنای خاص و متفاوت شکل گرفته است. فلسفه آلماتک این است که «تنها
                نخر»؛ یعنی خرید از آلماتک فقط تهیه کالا نیست، بلکه تجربه‌ای از
                کیفیت، تازگی و تنوع بی‌نظیر است. آلماتک با این نگاه توانسته
                جایگاه ویژه‌ای در ذهن مشتریان پیدا کند. »
            </p>
           
            <a
                referrerPolicy="origin"
                href="https://trustseal.enamad.ir/?id=681075&amp;Code=FSmtdCeiypMoUZyplam3VelanVQVfOWh"
            >
                <img
                    referrerPolicy="origin"
                    className="img-fluid rounded bg-white"
                    src="https://Trustseal.eNamad.ir/logo.aspx?id=681075&amp;Code=FSmtdCeiypMoUZyplam3VelanVQVfOWh"
                    alt=""
                    style={{ cursor: "pointer", width: "110px" }}
                    id="aX1AvQcH1oYyRD56CUPf"
                />
            </a>
            {/* "https://almatak.com/wp-content/uploads/2024/03/logo.aspx_.png"  */}
        </div>
    );
};

export default AboutUs;
